export function setWRequests(state, payload) {
  state.warehouse = payload;
}
